













import Widget from "@/components/common/Widget.vue";
import OposTable from "@/components/table/OposTable.vue";
import DashboardItemWrapper from "@/components/DashboardItems/DashboardItemWrapper.vue";
import Vue from "vue";

import Component from "vue-class-component";
import store from "@/store";

@Component({
  components: {
    Widget,
    DashboardItemWrapper,
    OposTable,
  },
})
export default class OPOSUebersichtstabelle extends Vue {
  public static id = "OPOSUebersichtstabelle";
  public static dprops = { width: 4, height: 4, minWidth: 4, minHeight: 4 };
  get _id() {
    return OPOSUebersichtstabelle.id;
  }
  get _dprops() {
    return OPOSUebersichtstabelle.dprops;
  }
  get planSelected() {
    return store.getters.planSelected;
  }
}
